(ns teamoesterreich.admin-mode.content.blog-admin
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.util.log :as log]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.blog :as d-blog]

            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]


            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            [teamoesterreich.admin-mode.ui-helper.image-drop-upload :as image-drop-upload]


            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.save :refer [save]]

            ))


(defn datetime-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" (subs dateTime 11 13) (subs dateTime 14 16) "00.000Z"))



(defn datetime-conv [dateTime]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count dateTime) 12)
    (str (subs dateTime 0 4) "-" (subs dateTime 4 6) "-" (subs dateTime 6 8) "T" (subs dateTime 9 11) ":" (subs dateTime 11 13)
         )
    ""
    ))

(defn get-it []
  (let [!form-data (r/atom {})]
    (fn []
      (let [!webBlog-list (r/cursor vstate/app-state [:webBlog-list])
            !loaded (r/cursor !webBlog-list [:loaded])
            !opened  (r/cursor !webBlog-list [:opened])
            !data (r/cursor !webBlog-list [:data @!opened])
            !publish-popup (r/cursor !webBlog-list [:show-publish-popup])
            !delete-popup (r/cursor !webBlog-list [:show-delete-popup])
            reload-fn #(reset! !loaded false)


            changed? (fn [key]
                       (log/debug "changed?" key (exists? (get @!form-data key)) (not= (get @!form-data key) (get @!data key)))
                       (and (exists? (get @!form-data key)) (not= (get @!form-data key) (get @!data key))))
            has-changes? (or
                           (changed? :webBlog-title)
                           (changed? :webBlog-date)
                           )
            change-fn (fn [key value]
                        (log/debug "change " key value)
                        (swap! !form-data assoc key value))
            ]
        (when-not @!loaded
          (do
            (d-blog/get-blog-list
              (fn [response]
                (swap! !webBlog-list assoc :loaded true :data response)))
            [mui/paper
             [:br]
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
             [mui/typography {} "Lade Daten ... "]
             ]
            ))
        (log/debug "Blog edit" @!data @!loaded @!form-data)
        (when-not @!data (a/set-page :blog-list))
        [mui/grid
         {:container  true
          :direction  "row"
          :alignItems "stretch"
          :justify    "flex-start"
          :style {:textAlign "left" :marginBottom "50px"}
          }
         [mui/grid
          {:item  true
           :xs    12
           :style {:height "50px"}
           }
          [mui/typography {:variant "h5" :style {:margin "12px 0 0 400px"}
                           :onClick reload-fn}
           "Artikel"]]

         [are-you-sure-modal/are-you-sure-modal !publish-popup
          "Bist du sicher, dass du diesen Artikel veröffentlichen möchtest? Alle Besucher werden den Artikel sehen können!" "Ja veröffentlichen"
          (fn [_] (d-blog/>webBlog-edit @!opened {:webBlog-published true}  reload-fn)) ]
         [are-you-sure-modal/are-you-sure-modal !delete-popup
          "Bist du sicher, dass du diesen Artikel löschen möchtest? " "Ja löschen"
          (fn [_]
            (d-blog/>webBlog-edit @!opened {:webBlog-active false} reload-fn)
            (a/set-page :blog-list)
            ) ]


         [mui/grid
          {:container false
           :item true
           :xl 7
           :xs 12  ;extra-small: 0px
           }

          [mui/card
           [mui/card-header
            {:title (str (:webBlog-title @!data))}]


           [mui/card-content


            [mui/card
             [mui/card-content
              [mui/grid
               {:container  true
                :direction  "row"
                :alignItems "stretch"
                :justify    "flex-start"
                :style {:textAlign "left"}
                }
              [mui/grid
               {:container false :item true
                :xs        12                                  ;extra-small: 0px
                :style     {:padding "5px"}
                }
               [(image-drop-upload/get-it (:webBlog-imageUri @!data)
                                          (fn [new-url]
                                            (d-blog/>webBlog-edit-img (:webBlog-uuid @!data) new-url reload-fn))
                                          {:width 400 :max-height 400})]
               ]

              [mui/grid
               {:container false :item true
                :xs        12                                  ;extra-small: 0px
                :style     {:padding "5px"}
                }
               [mui/text-field {
                                :style        {:backgroundColor (if (changed? :webBlog-title) "#ffd6d2" "#ffffff")}
                                :fullWidth    true
                                :InputLabelProps {:disableAnimation true :shrink true}
                                ;:disabled     (not @!edit-mode)
                                :defaultValue (str (:webBlog-title @!data))
                                :onChange     (fn [e] (change-fn :webBlog-title (h/event-value e)))
                                :label        "Artikel Titel"}]
               ]

              [mui/grid
               {:container false :item true
                :md        3                                   ;medium: 960px
                :xs        12                                  ;extra-small: 0px
                :style     {:padding "5px"}
                }

               [mui/text-field {
                                :style        {:backgroundColor (if (changed? :webBlog-date) "#ffd6d2" "#ffffff")}
                                :fullWidth    true
                                :InputLabelProps {:disableAnimation true :shrink true}
                                :type         "datetime-local"
                                :autoOk       true
                                :label        "Artikel Datum"
                                :onChange     (fn [e]
                                                (let [date (h/event-value e)
                                                      date (datetime-conv-back date)]
                                                  (change-fn :webBlog-date date)))
                                :defaultValue (datetime-conv (:webBlog-date @!data))
                                }]
               ]
              ]
             [mui/card-actions
              [mui/button {
                           :variant   "contained"
                           :startIcon (r/as-element [keyboard-arrow-left])
                           :disabled (not has-changes?)

                           } "Abbrechen"]

              [mui/button {
                           :variant   "contained"
                           :color "primary"
                           :startIcon (r/as-element [save])
                           :disabled (not has-changes?)
                           :onClick (fn [] (d-blog/>webBlog-edit (:webBlog-uuid @!data) @!form-data reload-fn))
                           } "Speichern"]
              ]
             ]]]







           [mui/card-content {:style {:textAlign "left" :marginLeft "20px"}}
            [(edit-md-card/get-it (:webBlog-longContent @!data)
                                  (fn [c] (d-blog/>webBlog-edit (:webBlog-uuid @!data) {:webBlog-longContent c} (fn [] (log/debug "Reload after save...") (reload-fn))))
                                  (str backend/BASE_URL "/media-upload")
                                  "Inhalt")]
            ]


           [mui/card-actions

            [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   (fn []
                                      (reset! !opened nil)
                                      (a/set-page :blog-list))
                         }
             "Schließen"
             ]
            [mui/form-group
             [mui/form-control-label
              {:style {:paddingLeft "126px"}
               :label "Artikel veröffentlichen"
               :fullWidth true
               :control (r/as-element
                          [mui/switch
                           {
                            :checked (or (get @!data :webBlog-published) false)
                            :onChange (fn [_ v]
                                        (if v (reset! !publish-popup true)
                                              (d-blog/>webBlog-edit @!opened {:webBlog-published false}  reload-fn)))
                            }])}
              ]]

            [mui/button {:startIcon (r/as-element [delete-forever])
                         :onClick #(reset! !delete-popup true)
                         :color "secondary"
                         :style {:marginLeft "150px"}
                         }
             "Löschen"
             ]

            ]]]

         ]))
    ))


